import React, { FC } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Tooltip } from 'antd';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import Text from 'antd/es/typography/Text';
import { onlyText } from 'react-children-utilities';

export interface CopiableProps {
  text?: string;
  style?: React.CSSProperties;
  stickyTooltip?: boolean;
  inline?: boolean;
}

export const Copiable: FC<CopiableProps> = (props) => {
  const { text = onlyText(props.children), style = {}, stickyTooltip = true, inline = false } = props;

  const [recentCopy, setRecentCopy] = React.useState<number>(null);

  const resetCopyIndicator = () => {
    window.clearTimeout(recentCopy)
    setRecentCopy(null)
  }

  React.useEffect(() => {
    if (recentCopy === 0)
      setRecentCopy(window.setTimeout(resetCopyIndicator, 3000))
  }, [recentCopy])

  const inner = (
    <>
      {props.children}
      <CopyToClipboard text={text} onCopy={() => { setRecentCopy(0) }}>
        <Tooltip
          placement="top"
          title={recentCopy ? 'Copied!' : 'Copy'}
          // always show 'Copied!' when recently copied
          visible={recentCopy && stickyTooltip ? true : undefined}
        >
          <Button
            size="small"
            icon={recentCopy ? <CheckOutlined /> : <CopyOutlined />}
            style={{ marginLeft: '.3rem', ...style }}
          >{recentCopy ? 'Copied' : 'Copy'}</Button>
        </Tooltip>
      </CopyToClipboard>
    </>
  )

  return (
    inline
      ? <span style={{ display: 'inline-block' }}>
        {inner}
      </span>
      : inner
  );
};

export const CodeBlock: FC<{ copiable?: boolean; inline?: boolean }> = (props) => {
  const { copiable = false, inline = false } = props;

  const Tag = inline ? 'div' : 'pre';
  const inner = (
    <Text
      style={inline ? {} : {
        flex: '1 0',
        marginRight: 8,
      }}
      code={!!inline}
    >
      {props.children}
    </Text>
  )

  return (
    <Tag
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
      }}
    >{copiable ? (
      <Copiable text={onlyText(props.children)} inline={inline} style={inline ? {} : {
        flexShrink: 0,
        margin: 10,
        position: 'sticky',
        right: 0,
      }}>
        {inner}
      </Copiable>
    ) : inner}
    </Tag>
  );
};
